import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import {
  Card,
  CardHeader,
  CardFooter,
  Pagination,
  PaginationItem,
  PaginationLink,
  Table,
  Container,
  Row,
  Button,
} from "reactstrap";

const useInterval = (callback, delay) => {
  const savedCallback = useRef();

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};

const ObtenerEquiposInstalados = (props) => {
  const [list1, setList1] = useState([]);
  const [valid, setValid] = useState(false); // Nuevo estado para validar
  const [errorMessage, setErrorMessage] = useState(""); // Nuevo estado para el mensaje de error
  const urlendpoint =
    "https://inspecciongnvback-dev.azurewebsites.net/api/v1/ObtenerEquipoInstalado/" +
    props.OrdenId;

  const fetchData = () => {
    axios({
      auth: {
        username: "admin.icontec@icontec.org",
        password: "quAngEraMuSTerGerEDE",
      },
      headers: {
        "Access-Control-Allow-Origin": "*",
      },
      method: "get",
      url: urlendpoint,
    })
      .then((Response) => {
        const data = Response.data;

        console.log("Datos recibidos:", data); // Agrega este console.log para verificar los datos

        // Filtrar registros por tipo
        const tieneTipo1 = data.some((item) => item.tipoEquipo == 1);
        const tieneTipo2 = data.some((item) => item.tipoEquipo == 2);

        // Desactivar temporalmente la validación para verificar si los datos se muestran
        setList1(data);

        if (tieneTipo1 && tieneTipo2 && data.length >= 2) {
          setValid(true); // Habilitar el botón "Siguiente"
          setErrorMessage(""); // Limpiar cualquier mensaje de error
        } else {
          setValid(false); // Deshabilitar el botón "Siguiente"
          setErrorMessage(
            "Debe tener al menos dos registros, uno de Cilindro 1 y otro Regulador",
          );
        }
      })
      .catch((error) => {
        console.log("Error al obtener datos:", error);
        setValid(false);
        setErrorMessage("Error al cargar los datos.");
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  useInterval(() => {
    fetchData();
  }, 6000);

  return (
    <Container className="mt--7" fluid>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="border-0">
              <h3 className="mb-0">Equipos</h3>
            </CardHeader>

            <Table className="align-items-center table-flush" responsive>
              <thead className="thead-light">
                <tr>
                  <th scope="col">Id</th>
                  <th scope="col">Nombre</th>
                  <th scope="col">Serial</th>
                  <th scope="col">Capacidad</th>
                  <th scope="col">Fecha Fabricación</th>
                  <th scope="col">Fecha Prox. Prueba</th>
                  <th scope="col">Fecha Ultima Prueba</th>
                  <th scope="col">Fecha Instalación</th>
                </tr>
              </thead>
              <tbody>
                {list1.length > 0 ? (
                  list1.map((item) => (
                    <tr key={item.id}>
                      <td>{item.id}</td>
                      <td>{item.nombreEquipo}</td>
                      <td>{item.serial}</td>
                      <td>{item.capacidad}</td>
                      <td>{item.fechaFabricacion}</td>
                      <td>{item.prueba}</td>
                      <td>{item.ultimaPrueba}</td>
                      <td>{item.fechaInstalacion}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" style={{ textAlign: "center" }}>
                      No hay datos para mostrar.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {errorMessage && (
              <div style={{ color: "red", marginTop: "10px" }}>
                {errorMessage}
              </div>
            )}

            <CardFooter className="py-4">
              <nav aria-label="...">
                <Pagination
                  className="pagination justify-content-end mb-0"
                  listClassName="justify-content-end mb-0"
                >
                  <PaginationItem className="disabled">
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                      tabIndex="-1"
                    >
                      <i className="fas fa-angle-left" />
                      <span className="sr-only">Previous</span>
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem className="active">
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      1
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      2 <span className="sr-only">(current)</span>
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      3
                    </PaginationLink>
                  </PaginationItem>
                  <PaginationItem>
                    <PaginationLink
                      href="#pablo"
                      onClick={(e) => e.preventDefault()}
                    >
                      <i className="fas fa-angle-right" />
                      <span className="sr-only">Next</span>
                    </PaginationLink>
                  </PaginationItem>
                </Pagination>
              </nav>
            </CardFooter>
          </Card>
        </div>
      </Row>
    </Container>
  );
};

export default ObtenerEquiposInstalados;
